import { render, staticRenderFns } from "./Starter.vue?vue&type=template&id=9ac9f85e"
import script from "./Starter.vue?vue&type=script&lang=js"
export * from "./Starter.vue?vue&type=script&lang=js"
import style0 from "./Starter.vue?vue&type=style&index=0&id=9ac9f85e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports